import {
  Component, Input, Output, EventEmitter,
} from '@angular/core';

import { BaseModalComponent } from '../_base-modal.component';
import { UserService } from '../../user/user.service';


@Component({
  moduleId: module.id,
  selector: 'plan-warning-modal',
  templateUrl: 'plan-warning-modal.component.html',
  styleUrls: ['plan-warning-modal.component.scss'],
})
export class PlanWarningModalComponent extends BaseModalComponent {
  @Input() isAddProducts: boolean = false;
  @Input() isAddUser: boolean = false;
  @Input() isAdmin: boolean = false;

  @Output() primaryBtnClick: EventEmitter<any> = new EventEmitter<any>();
  @Output() upgradePlanBtnClick: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private userService: UserService,
  ) {
    super();
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/

  get title() {
    if (this.isAddUser) {
      return 'You\'re gonna need more seatbelts';
    }
    return 'Oops, your tank is full!';
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onPimaryBtnClick() {
    this.hide();
    this.primaryBtnClick.emit();
  }

  onUpgradePlanClick() {
    this.hide();
    this.upgradePlanBtnClick.emit();
  }
}
